module.exports = require("@wildboar/x500/src/lib/modules/SelectedObjectClasses/groupOfNames.oa");